
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "version": "release-1.6.8",
    "branch": "release-1.6.8",
    "commit": "5e8e99f8e77f77eee6a71fefff550c4e723afb30",
    "pipeline": "1033"
};
/* tslint:enable */

